enum StorageKey {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  REGISTRATION_ID = 'registrationId',
  TEMP_ACCESS_TOKEN = 'temp-accessToken',
  TEMP_REFRESH_TOKEN = 'temp-refreshToken',
}

export { StorageKey };
